import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //手機模式
    mobileState: false,
    //0:測試模式 1:正式模式
    mode: 0,
    //loading progress overlay state
    overlayLoading: false,
    //整體顏色
    colorTextBlack: "#4f4f4f", //黑色文字
    colorTextWhite: "#FFF", //白色
    colorDefault: "#AEAEAE",
    colorPrimary: "#0078AF", //藍色
    colorPrimaryL: "#ccecfb", //淺藍色
    colorPrimaryD: "#00375A", //深藍色
    colorSecond: "#fdcd00", //黃色
    colorThird: "#ff8200", //橘色
    colorAlt: "#777",
    //系所名稱
    deptName: "大葉大學-D無窮學院",
    //系所簡稱
    deptSName: "大叶大学-D无穷学院",
    //英文縮寫
    EnDeptName: "Da-Yeh D infinity college",
    //系所連結
    deptLink: "https://dschool.dyu.edu.tw/",
    //頁面名稱
    pageName: "",
    //最新消息poolID
    poolId: 329,
    //橫幅poolID
    bannerPoolId: 1,
    // 媒體報導poolID
    mediaPoolID: 1,
    //活動花絮poolID
    activityPoolID: 1,
    //系所焦點poolID
    focusPoolID : 1,
    // 研究成果poolID
    researchreportPoolID:1,
    //快速連結
    fastLinkPoolId: 0,

    //單位ID，課程規劃，課程總表，法規專區用
    deptId: 1,
    
    //行政人員抓資料用
    unitId: 1,
    facebook:"https://www.facebook.com/people/%E5%A4%A7%E8%91%89%E5%A4%A7%E5%AD%B8Dschool/61551692536199/",
    lang: "zh-CN",
    //是否為測試，於App.vue設定
    isDemo: false,
    testURL: "tools/",
    onLineToolsURL: "onLineTools/",
    members: "members/",
    //siteSetting是否讀取結束
    siteSettingSuccess:false,
    mediaIsActive : true,
    activityIsActive:true
  },
  mutations: {
    //title name
    setPageName(state, name) {
      state.pageName = name;
    },
    isMobile(state) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        state.mobileState = true;
      } else {
        state.mobileState = false;
      }
    },
    setOverlayLoading(state, overlayState) {
      if (overlayState)
        state.overlayLoading = true;
      else
        state.overlayLoading = false;
    },
    scrollToTop(state) {
      let $content = $("#content");
      if ($content.length) { // 检查元素是否存在
        $("html,body").animate(
          {
            scrollTop: $content.offset().top,
          },
          "show"
        );
      }
      return false;
    },
    checkIsDemo(state) {
      var s = false
      if (location.hostname == "localhost" || location.hostname == "163.23.32.96") {
        s = true;
      } else {
        s = false;
      }
      state.isDemo = s;
      // alert(s)
      this.commit('siteSetting');
    },
    //網站配置
    siteSetting(state) {
      var self = this;
      var url = ""
      if (state.isDemo == 1) {
        url = state.testURL+"json/"
      } else {
        url = "siteSetting/"
      }
      axios(url + 'siteSetting.json')
        .then((response) => {
          state.colorAll = response.data.colorAll
          state.colorAllLight = response.data.colorAllLight
          state.deptName = response.data.deptName
          state.deptSName = response.data.deptSName
          state.EnDeptName = response.data.EnDeptName
          state.deptLink = response.data.deptLink
          state.poolId = response.data.poolId
          state.bannerPoolId = response.data.bannerPoolId
          state.mediaPoolID = response.data.mediaPoolID
          state.activityPoolID = response.data.activityPoolID
          state.focusPoolID = response.data.focusPoolID
          state.researchreportPoolID = response.data.researchreportPoolID
          state.fastLinkPoolId = response.data.fastLinkPoolId
          state.deptId = response.data.deptId
          state.unitId = response.data.unitId
          // state.lang = response.data.lang
          state.testURL = response.data.testURL
          state.onLineToolsURL = response.data.onLineToolsURL
          state.members = response.data.members
          // state.facebook = response.data.facebook
          state.mediaIsActive = response.data.mediaIsActive
          state.activityIsActive = response.data.activityIsActive
          state.siteSettingSuccess = true
          document.getElementById("pageTitle").innerHTML = response.data.deptName;
        })
        .catch((error) => console.log(error));


    }
  },
  actions: {

  },
  modules: {

  }
})
